/**
 * Procedure Categories and Procedures for MS in General Surgery students
 * Extracted with strict evidence from official NMC PDF (Page 10-11: "perform independently")
 */
export const GENERAL_SURGERY_PROCEDURES = {
  "Bedside & Resuscitative Surgical Procedures": [
    "Start IV Lines & C.V.P. Line Management",
    "Start & Monitor Blood Transfusion",
    "Venous Cut-Down",
    "Cardiopulmonary Resuscitation (BLS / ACLS) & Endotracheal Intubation",
    "Insert Nasogastric Tube & Urethral Catheterisation",
    "Infiltration, Surface & Digital Nerve Blocks",
    "Management of Pneumothorax & Pleural Space Collections",
    "Assessment, Resuscitation & Management of Burns",
    "Ultrasound FAST (Focused Abdominal Sonography in Trauma)",
  ],
  "Minor Surgical & Cutaneous Procedures": [
    "Surgical Management of Wounds & Control of External Hemorrhage",
    "Incision and Drainage of Superficial Abscesses & Management of Liver Abscess",
    "Diagnostic & Image-Guided Tissue Biopsies",
    "Excision of Skin and Subcutaneous Swellings",
    "Split Thickness Skin Grafting (STSG)",
    "Proctoscopy & Injection/Banding of Piles (Haemorrhoids)",
    "Vasectomy & Circumcision",
  ],
  "Operative General & Abdominal Surgical Procedures": [
    "Surgery for Hydrocele",
    "Open & Laparoscopic Repair of Hernias",
    "Hemithyroidectomy & Excision of Thyroglossal Cyst",
    "Excision Biopsy of Cervical & Axillary Lymph Nodes",
    "Excision of Benign Breast Lump, Gynaecomastia & Modified Radical Mastectomy",
    "Appendectomy (Open & Laparoscopic)",
    "Open & Laparoscopic Cholecystectomy",
    "Management of Intestinal Obstruction, Small Bowel Resection, Perforation & Anastomosis",
    "Colostomy Creation",
  ],
};

export const GENERAL_SURGERY_CATEGORIES = Object.keys(GENERAL_SURGERY_PROCEDURES);

export const isMSInGeneralSurgeryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("general surgery") && !d.includes("surgical gastro")) ||
    (d === "surgery")
  );
};
